// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"e1ae6fdf","625":"84efc53e","706":"cc727622","991":"99faed24"}[chunkId] + ".chunk.js";
};